
import React from 'react'
import _ from 'lodash'
import Grid from '@material-ui/core/Grid'
import ProfileSkillsStyled from './styled'
import { LinearPercentWithTitle } from '../../atoms'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from '../../../assets/i18n';

const ProfileSkills = ({ skills, clientLanguage, stateLanguage }) => {

  const activeLanguage = clientLanguage || stateLanguage
  i18n.setLanguage(activeLanguage)

  let skill = _.map(skills, (item, key) => {
    const value = _.get(item, 'value', '')
    const originalName = _.get(item, 'type.name', '')
    const translatedName = i18n.skillsTranslations?.[originalName] || originalName

    return (
      <Grid item key={key}>
        <LinearPercentWithTitle key={key} title={translatedName} value={Math.round(value)} />
      </Grid>

    )
  })

  if (skills && skills.length > 0) {
    return (
      <ProfileSkillsStyled>
        <Grid id='profileSkillsGridContainer' container direction="column" justifyContent="space-between" >
          {skill}
        </Grid>

      </ProfileSkillsStyled>
    )
  } else {
    return null
  }
}

ProfileSkills.propTypes = {
  skills: PropTypes.array,
}

const mapStateToProps = (state) => ({
  clientLanguage: state.auth.client?.lang,
  stateLanguage: state.auth.language
})

export default connect(mapStateToProps)(ProfileSkills)
